import { render, staticRenderFns } from "./NewsBannersDetail.vue?vue&type=template&id=06861c1c&scoped=true"
import script from "./NewsBannersDetail.vue?vue&type=script&lang=js"
export * from "./NewsBannersDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsBannersDetail.vue?vue&type=style&index=0&id=06861c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06861c1c",
  null
  
)

export default component.exports